import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import plusIcon from 'assets/images/icons/plus.svg';
import searchIcon from 'assets/images/icons/search.svg';
import AddDashboardOrPage from './AddDashboardOrPage';
import FormButton from 'components/form-components/FormButton';
import NestedTableWithDragComponent from 'components/nested-table-with-drag/NestedTableWithDrag';
import TextField from 'components/form-components/TextField';
import { CallAPI } from 'actions/General';
import {
  DashboardListPagesTableFields,
  DashboardTableFields,
  internalDashboardTabs,
} from './utils';
import { AuthReducer } from 'redux/auth';
import { useDispatch } from 'react-redux';

const AuthAction = AuthReducer.actions;

const DashboardList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dashboardsList, setDashboardsList] = useState([]);
  const [totalDashboard, setTotalDashboard] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterData, setFilterData] = useState({ searchText: '' });
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [selectedDashboardId, setSelectedDashboardId] = useState(null);
  const [addType, setAddType] = useState(null);

  const getDashboardsList = async () => {
    const result = await CallAPI(
      'GET_DASHBOARDS_LIST',
      { ...filterData, page: 1, limit: 10 },
      null,
      setLoader,
    );
    if (result.status) {
      setDashboardsList(result.data);
      setTotalDashboard(20);
    }
  };

  const handleFilterChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleCloseEditModal = () => {
    setSelectedRecordId(null);
    setAddType(null);
  };

  const dashboardActionsCallBack = (action, data) => {
    if (action === 'edit') {
      setSelectedRecordId(data.id);
      setAddType('dashboard');
    } else if (action === 'refresh') {
      getDashboardsList();
    }
  };

  const pageActionsCallBack = (action, data) => {
    if (action === 'edit') {
      setSelectedRecordId(data.id);
      setAddType('page');
    } else if (action === 'refresh') {
      getDashboardsList();
    }
  };

  const goToDashboardPage = (dashboardId, pageId) => {
    navigate('/dashboards/view', { relative: 'path', state: { dashboardId, pageId } });
  };

  const openAddPageModal = (dashboardId) => {
    setAddType('page');
    setSelectedDashboardId(dashboardId);
  };

  useEffect(() => {
    getDashboardsList();
  }, [filterData]);

  useEffect(() => {
    dispatch(
      AuthAction.updateBreadCrumb({ breadcrumbs: internalDashboardTabs[0].breadcrumbValue }),
    );
  }, [dispatch]);

  return (
    <div className='container-fluid p-4 bg-white rounded-2'>
      <div className='mb-3 d-flex justify-content-between'>
        <TextField
          placeholder='field_search'
          icon={searchIcon}
          name='searchText'
          value={searchText}
          handleChange={(_, value) => setSearchText(value)}
          debounceFunc={handleFilterChange}
        />
        <FormButton
          onClick={() => setAddType('dashboard')}
          text='button_add_new'
          icon={plusIcon}
          iconClasses='svg-white'
          variant='green-1'
        />
      </div>
      <NestedTableWithDragComponent
        header={DashboardTableFields}
        data={dashboardsList}
        props={{
          type: 'dashboards',
          actionsType: 'dashboards',
          actionsCallBack: dashboardActionsCallBack,
          openAddPageModal,
          isDragable: false,
        }}
        totalRecords={totalDashboard}
        filterEnabled={false}
        loader={loader}
        isFieldSelectionEnabled={false}
        isPaginationEnabled={true}
        isActionsEnabled={true}
        isSelectionEnabled={false}
        selectionKey={'_id'}
        paginationFunction={getDashboardsList}
        // onSelection={onRowsSelection}
        selectedRows={[]}
        nestedTableProps={{
          isNestedTableAllowed: true,
          isDragable: false,
          nestedTableDataKey: 'pages',
          nestedTableHeader: DashboardListPagesTableFields,
          props: {
            goToDashboardPage,
            isActionsEnabled: true,
            selectionKey: '_id',
            actionsType: 'dashboard_pages',
            actionsCallBack: { dashboardsList, pageActionsCallBack },
          },
        }}
      />
      {addType && (
        <AddDashboardOrPage
          editId={selectedRecordId}
          selectedDashboardId={selectedDashboardId}
          onCancel={handleCloseEditModal}
          refreshList={getDashboardsList}
          type={addType}
        />
      )}
    </div>
  );
};

export default DashboardList;
